import { pageInfoFragment } from "@saleor/fragments/pageInfo";
import makeTopLevelSearch from "@saleor/hooks/makeTopLevelSearch";
import gql from "graphql-tag";

import {
  SearchLanguages,
  SearchLanguagesVariables
} from "./types/SearchLanguages";

export const searchLanguages = gql`
  ${pageInfoFragment}
  query SearchLanguages($after: String, $first: Int!, $query: String!) {
    search: languages(
      after: $after
      first: $first
      filter: { search: $query }
    ) {
      edges {
        node {
          id
          language
          languageCode
        }
      }
      pageInfo {
        ...PageInfoFragment
      }
    }
  }
`;

export default makeTopLevelSearch<SearchLanguages, SearchLanguagesVariables>(
  searchLanguages
);
